import { AlertCircle } from "lucide-react";

interface RunErrorNoticeProps {
  message: string;
}

// Why a response stopped, rendered at the end of the turn that failed. Shows the
// live RUN_ERROR and, after a reload, the persisted marker — one component, so
// the two are identical. The support reference lives in the turn actions menu:
// it's a trace id, unreadable at a glance and only useful pasted.
export const RunErrorNotice = ({ message }: RunErrorNoticeProps) => (
  <div
    className="flex items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/[0.06] px-3 py-2 text-xs leading-relaxed text-destructive"
    role="status"
    aria-live="polite"
  >
    <AlertCircle className="mt-0.5 size-3.5 shrink-0" aria-hidden />
    <p className="min-w-0">{message}</p>
  </div>
);
